export const unavailabilityConstants = {
    START: 'unavailability:start',
    STOP: 'unavailability:stop',
    UNAVAILABILITY: 'unavailability:unavailability',
    ADD: 'unavailability:add',
    UPDATE: 'unavailability:update',
    REMOVE: 'unavailability:delete',
    CLEAR: 'unavailability:clear',
};
